import { defineRecipe } from "@pandacss/dev";

export const aromaBadge = defineRecipe({
  className: "aroma-badge",
  jsx: ["Badge"],
  base: {
    height: "xs",
    borderRadius: "pill",
    textStyle: "mono.s.regular",
    color: "content.neutral.reverse.bold",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    px: "padding.1,5",
    _aromaticonChildren: {
      fontSize: "{sizes.3xs}",
    },
  },
  variants: {
    chip: {
      true: {
        width: "4xs",
        height: "4xs",
        minWidth: "4xs",
        minHeight: "4xs",
        px: "unset",
      },
    },
    icon: {
      true: {
        width: "xs",
        px: "unset",
      },
    },
    function: {
      neutral: {
        bgColor: "background.neutral.base.bold",

        _withinWhiteLabelTheme: {
          bgColor: "background.brand.bold",
          color: "content.neutral.bold",
        },
      },
      info: {
        bgColor: "background.functional.info.bold",
      },
      success: {
        bgColor: "background.functional.success.bold",
      },
      warning: {
        bgColor: "background.functional.warning.bold",
      },
      error: {
        bgColor: "background.functional.error.bold",
      },
      ai: {
        bg: "background.ai.bold",
      },
    },
    outlined: {
      true: {
        outlineWidth: "m",
        outlineStyle: "solid",
        outlineColor: "border.neutral.subtlest",
        _withinWhiteLabelTheme: {
          outlineColor: "border.neutral-on-brand.bold",
        },
      },
    },
  },
  defaultVariants: {
    function: "neutral",
  },
});
